import React from 'react'
import "../../stylings/facility.css"
import learn            from '../../assest/lifeatschool/Yoga.jpeg'
import activity         from '../../assest/lifeatschool/Champion.jpeg'
import digitalClassroom from '../../assest/lifeatschool/Christmas.jpeg'
import personalDev      from '../../assest/lifeatschool/Computer.jpeg'
import play             from '../../assest/lifeatschool/NDRF.jpeg'

const tiles = [
  {
    img: learn,
    icon: 'fa-solid fa-brain',
    title: 'Concept Based Learning',
    desc: 'Beyond memorising facts — we help students understand, question and connect ideas to the world around them.',
    cls: 'las-item--hero',
  },
  {
    img: activity,
    icon: 'fa-solid fa-trophy',
    title: 'Activities & Sports',
    desc: 'Co-curricular activities that sharpen teamwork, creativity and leadership alongside academics.',
    cls: '',
  },
  {
    img: play,
    icon: 'fa-solid fa-futbol',
    title: 'Play & Recreation',
    desc: 'Dedicated playgrounds for cricket and other sports, giving every student space to grow physically.',
    cls: '',
  },
  {
    img: personalDev,
    icon: 'fa-solid fa-heart-pulse',
    title: 'Personal Development',
    desc: 'Building emotional resilience, wellness habits and life skills that go well beyond the classroom.',
    cls: '',
  },
  {
    img: digitalClassroom,
    icon: 'fa-solid fa-desktop',
    title: 'Digital Classrooms',
    desc: 'Technology-driven learning environments that prepare students for the challenges of tomorrow.',
    cls: 'las-item--wide',
  },
]

const Facilities = () => {
  return (
    <section className="las-section">
      <div className="container">

        {/* ── Header ── */}
        <div className="las-header">
          <div className="las-header-left">
            <div className="las-tag">
              <i className="fa-solid fa-star"></i>
              School Life
            </div>
            <h2 className="las-title">Life at Vidya Jain Convent School</h2>
            <p className="las-subtitle">
              A vibrant campus where learning, wellness, creativity and character development go hand in hand.
            </p>
          </div>

          {/* stat pills */}
          <div className="las-stats">
            <div className="las-stat">
              <span className="las-stat-num">20+</span>
              <span className="las-stat-lbl">Years of Excellence</span>
            </div>
            <div className="las-stat-div"></div>
            <div className="las-stat">
              <span className="las-stat-num">1500+</span>
              <span className="las-stat-lbl">Happy Students</span>
            </div>
            <div className="las-stat-div"></div>
            <div className="las-stat">
              <span className="las-stat-num">50+</span>
              <span className="las-stat-lbl">Dedicated Faculty</span>
            </div>
          </div>
        </div>

        {/* ── Bento grid ── */}
        <div className="las-grid">
          {tiles.map((tile, i) => (
            <div key={i} className={`las-item ${tile.cls}`}>
              {/* image */}
              <img src={tile.img} alt={tile.title} className="las-img" />

              {/* permanent dark vignette */}
              <div className="las-vignette"></div>

              {/* always-visible bottom label */}
              <div className="las-label">
                <span className="las-label-icon"><i className={tile.icon}></i></span>
                <span className="las-label-title">{tile.title}</span>
              </div>

              {/* hover panel slides up */}
              <div className="las-hover-panel">
                <div className="las-hover-icon"><i className={tile.icon}></i></div>
                <h4 className="las-hover-title">{tile.title}</h4>
                <p className="las-hover-desc">{tile.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default Facilities
